import { store } from '../store'
import { setClientVersion, setServerVersion } from '../store/modules/app'

import { BASE_URL } from './http'
import * as sentry from './sentry'

export async function setupConstants (): Promise<void> {
  let response = await fetch(`${BASE_URL}/constants`)
  let constants = await response.json()

  store.dispatch(setClientVersion({
    ref: constants.COMMIT?.trim() ?? undefined,
    date: constants.RELEASE_DATE?.trim() ?? undefined
  }))

  store.dispatch(setServerVersion({
    ref: constants.COMMIT?.trim() ?? undefined,
    date: constants.RELEASE_DATE?.trim() ?? undefined
  }))

  window.constants = constants
}

export async function setup (): Promise<void> {
  await setupConstants()
  sentry.init()
}
